import { useEffect, useState } from 'react';
import { supabase } from '../../../../../utils/supabaseClient';

export function useCollectionStats(collectionId) {
  const [stats, setStats] = useState({
    artworks_total: 0,
    artworks_accepted: 0,
    artists_total: 0,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let ignore = false;
    async function fetchStats() {
      try {
        setStats((s) => ({ ...s, loading: true, error: null }));
        // Get mapping rows for the collection
        const { data: mappings, error: mapError } = await supabase
          .from('collection_vc_mapping')
          .select('vc_id, accepted')
          .eq('collection_id', collectionId);
        if (mapError) throw mapError;

        const total = (mappings || []).length;
        const accepted = (mappings || []).filter((m) => m.accepted === true).length;
        let artists = 0;

        const vcIds = (mappings || []).map((m) => m.vc_id).filter(Boolean);
        if (vcIds.length > 0) {
          const { data: vcsRows, error: vcsError } = await supabase
            .from('vcs')
            .select('uuid, vc_id')
            .in('vc_id', vcIds);
          if (vcsError) throw vcsError;
          const uniqueArtists = new Set((vcsRows || []).map((r) => r.uuid).filter(Boolean));
          artists = uniqueArtists.size;
        } else {
          // Fallback: some datasets store collection_id directly on vcs
          const { data: vcsRows, error: vcsFallbackError } = await supabase
            .from('vcs')
            .select('uuid')
            .eq('collection_id', collectionId);
          if (vcsFallbackError) throw vcsFallbackError;
          const uniqueArtists = new Set((vcsRows || []).map((r) => r.uuid).filter(Boolean));
          artists = uniqueArtists.size;
        }

        if (!ignore) {
          setStats({
            artworks_total: total,
            artworks_accepted: accepted,
            artists_total: artists,
            loading: false,
            error: null,
          });
        }
      } catch (e) {
        if (!ignore) setStats((s) => ({ ...s, loading: false, error: e }));
      }
    }
    if (collectionId) fetchStats();
    return () => { ignore = true; };
  }, [collectionId]);

  return stats;
}
